<!-- orderConfirmProductList -->
<template>
  <div>
    <div v-for="(item, index) in productList" :key="index" class="productInfo">
      <div class="taocan">
        <p>
          <b v-if="item.packageLabel">{{ item.packageLabel }}</b> {{ item.courseName }}
        </p>
        <span v-if="!memberPackage">包含以下课程：</span>
      </div>
      <ul class="productInfoList" v-if="!memberPackage">
        <li v-for="(val, key) in item.packageProductSkuReqList" :key="key" class="productInfo">
          <div>
            <p :class="['productName ellipsis-2', { subProduct: val.product.subProduct }]">
              <span v-if="val.product.type" class="productType">{{
                productTypeMap[val.product.type]
              }}</span>
              <span v-if="val.product.promotion" class="promotionType">{{
                val.product.promotion
              }}</span>
              <i
                v-if="val.product.name && specialTextList.includes(val.product.name[0])"
                class="textPlaceHolder"
              ></i>
              <span class="productText">
                <!-- <i v-if="product.name.substr(0,1)=='【'" class="title-special-processing-small"/> -->
                {{ val.product.name }}
              </span>
              <!-- <a v-if="product.protocol" class="productProtocol">查看协议</a> -->
            </p>
            <p class="productSpecs">{{ String(val.product.specs) }}</p>
          </div>
          <p class="productPrice" v-if="!hasDirectAccommodation">￥{{ val.product.price }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const productTypeMap = {
  add: '增值',
  gift: '赠品',
};

const specialTextList = ['【'];

export default {
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
    packageDetail: {
      type: Object,
      default: () => {},
    },
    memberPackage: {
      type: Boolean,
      default: false,
    },
    hasDirectAccommodation:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      productTypeMap,
      specialTextList,
    };
  },
};
</script>

<style lang="scss">
.taocan {
  margin: 0 0 20px 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(151, 151, 151, 0.1);

  p {
    padding: 30px 0 6px 0;
    color: #333;
    font-size: 29px;
    line-height: 40px;
    b {
      padding: 2px 8px;
      color: #fff;
      font-size: 22px;
      background: #ff6c02;
      border-radius: 4px;
    }
  }
  span {
    color: #333;
    font-size: 25px;
  }
}
.productList {
  .productInfoList {
    .productInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 29px 0;
      border-bottom: 2px solid #f5f5f6;

      &:last-child {
        border-bottom: none;
      }

      .textPlaceHolder {
        margin-left: -10px;
      }

      .productName {
        max-width: 520px;
        color: #333;
        font-size: 25px;
        line-height: 36px;

        .productType,
        .promotionType {
          position: relative;
          top: -2px;
          height: 31px;
          margin-right: 4px;
          padding: 0 7px;
          color: #ff6c02;
          font-weight: bold;
          font-size: 22px;
          border: 1px solid #ff6c02;
          border-radius: 4px;
        }

        .promotionType {
          color: #fff;
          background: #ff6c02;
        }

        &.subProduct {
          color: #787878;
          font-size: 22px;
        }
      }

      .productSpecs {
        height: 31px;
        margin-top: 7px;
        color: #a5a5a5;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
      }

      .productProtocol {
        margin-left: 14px;
        color: #ff6c02;
        font-size: 22px;
        text-decoration: underline;
        cursor: pointer;
      }

      .productPrice {
        color: #ff791b;
        font-size: 25px;
      }
    }
  }
}
</style>
